import { Link } from "react-router-dom";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import images from "@/utils/images";
import { providerRoute as provider } from "@/config/roles";

export function DraftNotesCard(props) {
  const { numberOfDraftNotes } = props;

  const subText =
    numberOfDraftNotes > 0 ? (
      <Link className="draft-notes-view-all fs-16" to={provider + "/draft-notes"}>
        View All
      </Link>
    ) : (
      <p className="draft-note-sub-text fs-16">Great Job!</p>
    );

  return (
    <DashboardCard2 className="tw:justify-between" rawChildren>
      <div className="d-flex align-items-center justify-content-between">
        <p className="fs-30 fs-xl-50 mb-0 tw:font-bold">{numberOfDraftNotes}</p>
        <img className="draft-note-icon d-none d-md-block" src={images("./icons/draft-note.svg")} />
      </div>

      <div className="d-flex flex-column">
        <p className="fs-lg-20 fs-14 mt-3 mb-0">Number Of Draft Notes</p>
        {subText}
      </div>
    </DashboardCard2>
  );
}
